import { Brick } from './account/contract-order-brick.model';
import { NominationRule } from './nominations/nomination-rule.model';

export class HtmlTooltipData {
  headerMap: Map<string, string>;
  contractualBricks: Map<string, string>;
  nonContractualBricks: Map<string, string>;
  settlementBricks: { code: string; value: number }[];
  dataList: string[][];
  htmlTranslate: boolean = false;
  headerMapTitle: string;
  htmlString: string;
  stringList: string[];
  sitesList: string[];
  contractsList: string[];
  hasNoBricks: boolean;
  dataConstant: string[][];

  transactionRuleBricks: Brick[];
  transactionRuleBricksTotal: number;
  transactionRuleBricksShowTotal: boolean;
  nominationRule: NominationRule;

  constructor(attributes: Partial<HtmlTooltipData> = {}) {
    Object.assign(this, attributes);
  }
}
